<div class="sgt-canal-venda-input-group" *ngIf="canalVenda">
    <div class="input-group">
        <div class="input-group-prepend" *ngIf="canalVenda.logoMiniURL">
            <span class="input-group-text">
                <sgt-canal-venda-logo-badge
                    [logoMiniURL]="canalVenda.logoMiniURL"
                    [useAsMini]="true"
                    [isShowNome]="false"
                    [nome]="canalVenda.nome"
                    [styles]="{
                        width: '25px',
                        height: '25px'
                    }">
                </sgt-canal-venda-logo-badge>
            </span>
        </div>
        <input type="text" class="form-control" [value]="canalVenda.nome ? canalVenda.nome : ''" disabled="disabled" readonly="readonly" title="{{canalVenda.descricao ? canalVenda.descricao : ''}}">
    </div>
</div>